export const Foo = 'Foo';
export interface Foo {
    baz: string;
}
